import React, { useState, useEffect, useMemo } from "react";
import { Drawer, Form, Input, Select, Switch, Button, Typography } from "antd";
import JoditEditor from "jodit-react";
import { FaChartLine } from "react-icons/fa";
import { request } from "../../../functions/request";
import { toast } from "react-toastify";
import PaletaTokens from "../Automacao/PaletaTokens";

function ModalAddModelo({ isOpen, onClose, editData, onSaved }) {
  const [nome, setNome] = useState("");
  const [tipo, setTipo] = useState("noticia");
  const [ativo, setAtivo] = useState(true);
  const [content, setContent] = useState("");
  const [paletaAberta, setPaletaAberta] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNome(editData?.mod_nome || "");
      setTipo(editData?.mod_tipo || "noticia");
      setAtivo(editData?.mod_ativo ?? true);
      setContent(editData?.mod_conteudo || "");
    }
  }, [isOpen, editData]);

  // Config precisa de identidade estável entre renders, senão o jodit-react
  // recria a instância inteira do editor a cada re-render (veja o mesmo fix
  // aplicado em EditorNoticia.js/EditorAnalise.js).
  const joditConfig = useMemo(
    () => ({
      language: "pt_br",
      width: "100%",
      minHeight: "350px",
      spellcheck: true,
      spellcheckLang: "pt-BR",
    }),
    []
  );

  const saveData = async () => {
    if (!nome.trim() || !content.trim()) {
      toast.error("Preencha o nome e o conteúdo do modelo!");
      return;
    }

    try {
      const payload = {
        newData: {
          mod_nome: nome,
          mod_conteudo: content,
          mod_tipo: tipo,
          mod_ativo: ativo ? 1 : 0,
        },
      };

      if (editData?.mod_codigo) {
        await request(`/modelo/updateModelo/${editData.mod_codigo}`, {
          method: "PUT",
          body: JSON.stringify(payload),
        });
      } else {
        await request("/modelo/insertModelo", {
          method: "POST",
          body: JSON.stringify(payload),
        });
      }

      toast.success("Modelo salvo com sucesso!");
      onClose();
      onSaved();
    } catch (err) {
      console.log(err);
      toast.error("Erro ao salvar modelo!");
    }
  };

  return (
    <Drawer
      title={editData?.mod_codigo ? "Editar Modelo" : "Adicionar Novo Modelo"}
      open={isOpen}
      onClose={onClose}
      width={720}
      extra={
        <Button type="primary" onClick={saveData}>
          Salvar
        </Button>
      }
    >
      <Form layout="vertical">
        <Form.Item label="Nome do Modelo">
          <Input value={nome} onChange={(e) => setNome(e.target.value)} />
        </Form.Item>
        <Form.Item label="Tipo">
          <Select
            value={tipo}
            onChange={(value) => setTipo(value)}
            options={[
              { value: "noticia", label: "Notícias" },
              { value: "ambos", label: "Notícias e Análises" },
            ]}
          />
        </Form.Item>
        <Form.Item label="Ativo">
          <Switch checked={ativo} onChange={(v) => setAtivo(v)} />
        </Form.Item>
        <Form.Item
          label="Conteúdo"
          extra={
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              Marcadores como <code>{"{{cotacao:16|uf=MT}}"}</code> são trocados pelo valor do
              banco quando o modelo é usado por uma automação.
            </Typography.Text>
          }
        >
          <Button
            icon={<FaChartLine />}
            onClick={() => setPaletaAberta(true)}
            style={{ marginBottom: 8 }}
          >
            Inserir valor de mercado
          </Button>
          {isOpen && (
            <JoditEditor value={content} config={joditConfig} onBlur={(newContent) => setContent(newContent)} />
          )}
        </Form.Item>
      </Form>

      {/* O Jodit devolve o conteúdo só no onBlur, então o token é somado
          ao fim do texto e o redator arrasta para o lugar. Inserir no
          cursor exigiria mexer na instância do editor, e isso já deu
          dor de cabeça no EditorNoticia. */}
      <PaletaTokens
        aberta={paletaAberta}
        onFechar={() => setPaletaAberta(false)}
        onInserir={(token) => {
          setContent((atual) => `${atual || ""}<p>${token}</p>`);
          toast.info("Marcador inserido no fim do modelo — arraste para a posição desejada.");
        }}
      />
    </Drawer>
  );
}

export default ModalAddModelo;
